document.addEventListener("DOMContentLoaded", () => {

  const sliders = document.querySelectorAll(".ba-slider");

  sliders.forEach((slider) => {

    const resize = slider.querySelector(".resize");
    const divider = slider.querySelector(".divider");

    if (!resize || !divider) return;

    let dragging = false;

    // Initial Position
    setPosition(50);

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));

      resize.style.width = percent + "%";
      divider.style.left = percent + "%";
    }

    function getPercent(clientX) {
      const rect = slider.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function startDrag(e) {
      e.preventDefault();
      dragging = true;
      slider.classList.add("dragging");
    }

    function stopDrag() {
      dragging = false;
      slider.classList.remove("dragging");
    }

    function drag(e) {
      if (!dragging) return;
      setPosition(getPercent(e.clientX));
    }

    function touchDrag(e) {
      if (!dragging) return;
      setPosition(getPercent(e.touches[0].clientX));
    }

    // Mouse
    slider.addEventListener("mousedown", startDrag);

    window.addEventListener("mousemove", drag);
    window.addEventListener("mouseup", stopDrag);

    // Touch
    slider.addEventListener("touchstart", startDrag,{
        passive:true
    });

    window.addEventListener("touchmove", touchDrag, {
      passive: true
    });

    window.addEventListener("touchend", stopDrag);

    // Click anywhere
    slider.addEventListener("click", function(e) {

      if (dragging) return;

      setPosition(getPercent(e.clientX));

    });

    // Resize Fix
    window.addEventListener("resize", () => {
      const current =
        parseFloat(resize.style.width) || 50;

      setPosition(current);
    });

  });

});